import { render, staticRenderFns } from "./FormFiscalNature.vue?vue&type=template&id=6ff436fe"
import script from "./FormFiscalNature.vue?vue&type=script&lang=js"
export * from "./FormFiscalNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports